
import { useTranslation } from "react-i18next";
import { FC, useMemo } from "react";
import {
    BottomBar,
    BottomBarContent,
    ProjectName,
    ButtonHolder,
    ArrowRightIcon,
    LeftColumn
} from "./styles";
import { SelectedProjectDesc } from "shared/modals/sendProjects/styles";
import {BrgButton, ButtonVariant, FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";



interface PropsT {
    onPublish: () => void;
    onDeselect: () => void;
    selectedProjectName?: string;
    selectedCount?: number;
    maxProjects?: number;
    isEmptyRequest?: boolean;
    disabled?: boolean;
}

const CompetitionSelectPanel: FC<PropsT> = ({
    onPublish,
    onDeselect,
    selectedCount,
    selectedProjectName,
    maxProjects,
    isEmptyRequest,
    disabled,
}) => {
    const { t } = useTranslation();

    const titleText = useMemo(() => {
        if (maxProjects === 1 && selectedProjectName) {
            return t('competition.selected_project', { name: selectedProjectName });
        }
        return t('competition.selected_projects_panel', { count: selectedCount })
    }, [selectedCount, t, selectedProjectName, maxProjects]);

    if (!selectedCount && !isEmptyRequest) {
        return null;
    }

    return (
        <BottomBar>
            <BottomBarContent justify={isEmptyRequest ? 'flex-end' : 'space-between'}>
                {!isEmptyRequest && (
                    <LeftColumn>
                        <ProjectName>
                            {titleText}
                        </ProjectName>
                        {!!maxProjects && (
                            <SelectedProjectDesc>
                                {t('competition.max_projects', { count: maxProjects })}
                            </SelectedProjectDesc>
                        )}
                    </LeftColumn>
                )}
                <ButtonHolder>
                    {!isEmptyRequest && (
                        <BrgButton variant={ButtonVariant.Hollow} onClick={onDeselect}>
                            {t('competition.deselect')}
                        </BrgButton>
                    )}
                    <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={onPublish}>
                        {t('competition.send')}
                        <ArrowRightIcon />
                    </BrgButton>
                </ButtonHolder>
            </BottomBarContent>
        </BottomBar>
    )
}

export default CompetitionSelectPanel;
import { useTranslation } from "react-i18next";
import { FC, useMemo } from "react";
import {
    BottomBar,
    BottomBarContent,
    ProjectName,
    ButtonHolder,
    ArrowRightIcon,
    LeftColumn
} from "./styles";
import { SelectedProjectDesc } from "shared/modals/sendProjects/styles";
import {BrgButton, ButtonVariant, FlexBox, useBreakpoint, useIsMobile} from "@brg/ui";



interface PropsT {
    onPublish: () => void;
    onDeselect: () => void;
    selectedProjectName?: string;
    selectedCount?: number;
    maxProjects?: number;
    isEmptyRequest?: boolean;
    disabled?: boolean;
}

const CompetitionSelectPanel: FC<PropsT> = ({
    onPublish,
    onDeselect,
    selectedCount,
    selectedProjectName,
    maxProjects,
    isEmptyRequest,
    disabled,
}) => {
    const { t } = useTranslation();

    const titleText = useMemo(() => {
        if (maxProjects === 1 && selectedProjectName) {
            return t('competition.selected_project', { name: selectedProjectName });
        }
        return t('competition.selected_projects_panel', { count: selectedCount })
    }, [selectedCount, t, selectedProjectName, maxProjects]);

    if (!selectedCount && !isEmptyRequest) {
        return null;
    }

    return (
        <BottomBar>
            <BottomBarContent justify={isEmptyRequest ? 'flex-end' : 'space-between'}>
                {!isEmptyRequest && (
                    <LeftColumn>
                        <ProjectName>
                            {titleText}
                        </ProjectName>
                        {!!maxProjects && (
                            <SelectedProjectDesc>
                                {t('competition.max_projects', { count: maxProjects })}
                            </SelectedProjectDesc>
                        )}
                    </LeftColumn>
                )}
                <ButtonHolder>
                    {!isEmptyRequest && (
                        <BrgButton variant={ButtonVariant.Hollow} onClick={onDeselect}>
                            {t('competition.deselect')}
                        </BrgButton>
                    )}
                    <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={onPublish}>
                        {t('competition.send')}
                        <ArrowRightIcon />
                    </BrgButton>
                </ButtonHolder>
            </BottomBarContent>
        </BottomBar>
    )
}

export default CompetitionSelectPanel;